<template>
    <section>
        <div id="order_view_model" class="modal" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <b class="pull-left">Table #: {{this.selectedTable.name}} -- {{(this.order.waiter === null || this.order.waiter === undefined) ? 'No Waiter' : this.order.waiter.name}}</b>
                        </h4>
                        <br/>
                    </div>
                  <form  @submit.prevent="$parent.submitOrderObject(cashTaken)">
                    <div class="modal-body">
                        <div style="text-align:center;" v-if="order.paymentMethod.id === 1">
                            <h4>Enter Cash Taken</h4>
                          <PosCashTakenKeyPad ref="keyPad" :billedPrice="order.billedPrice" @cashTaken="cashTakenFromPad" v-if="order.paymentMethod.id===1"/>
                        </div>
                        <legend>Order Items</legend>
                        <table class="table table-bordered table-hover table-stripped">
                            <thead>
                            <tr>
                                <th class="text-center">Name</th>
                                <th class="text-center">Serving</th>
                                <th class="text-center">Price</th>
                                <th class="text-center">Quantity</th>
                                <th class="text-center">Total Price</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="(orderItem, orderItemIndex) in order.orderItemsById">
                                <tr  v-bind:key="orderItemIndex+'_'+orderItem.id">
                                    <td class="text-center">{{orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name}}</td>
                                    <td class="text-center">{{orderItem.menuItemTypesByMenuItemTypeId.serving}}</td>
                                    <td class="text-center">{{orderItem.menuItemTypesByMenuItemTypeId.price}}</td>
                                    <td class="text-center">{{orderItem.quantity}}</td>
                                    <td class="text-center">{{orderItem.totalPrice}}</td>
                                </tr>
                                <template v-for="(itemAddOn, index) in orderItem.orderItemAddOnsById">
                                    <tr v-bind:key="index+'_'+orderItemIndex+'_'+itemAddOn.addOnItemsByAddOnItemId.name">
                                        <td colspan="2" class="text-right"><b>Add On</b></td>
                                        <td class="text-center">{{itemAddOn.addOnItemsByAddOnItemId.name}}</td>
                                        <td class="text-center">{{itemAddOn.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.name}}</td>
                                        <td class="text-center">{{(itemAddOn.quantity * itemAddOn.addOnItemsByAddOnItemId.price) + ' => (' + itemAddOn.addOnItemsByAddOnItemId.price + ' X ' + itemAddOn.quantity + ')'}}</td>
                                    </tr>
                                </template>
                            </template>
                            <tr>
                                <td colspan="4" class="text-right">Sub Total</td>
                                <td class="text-right">{{order.totalPriceWithAddon | formatNumber}} Rs.</td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="4">Tax Amount <b v-if="order.paymentMethod.id===1" class="text-info">({{order.branchesByBranchId.tax}}%)</b><b v-if="order.paymentMethod.id===2" class="text-info">({{order.branchesByBranchId.cardTax}}%)</b></td>
                                <td class="text-right" v-if="order!==''">{{Math.round(this.order.totalPriceAfterTax - this.order.totalPriceWithAddon )}} Rs.</td>
                            </tr>                            
                            <tr>
                                <td colspan="3" class="text-right">
                                        <div class="input-group ">
                                            <input v-model="discountCode" :disabled="order.discount>0" type="text" class="form-control" placeholder="Discount Coupon..." />
                                            <span class="input-group-btn">
                                                <button type="button" v-on:click="applyDiscount()" :disabled="order.discount>0" class="btn btn-primary"><i class="fa fa-check"></i></button>
                                                <button title="Remove Discount" type="button" :disabled="order.discount===0" v-on:click="removeDiscount()" class="btn btn-danger myTip"><i class="fa fa-times"></i></button>
                                            </span>
                                        </div>
                                </td>
                                <td class="text-right">Discount</td>
                                <td class="text-right">{{$parent.selectedTableOrder.discount | formatNumber}} Rs.</td>
                            </tr>
                            <tr>
                                <td colspan="4" class="text-right">Billed Amount</td>
                                <td class="text-right" >{{order.billedPrice | formatNumber}} Rs.</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <p v-if="Number(cashTaken) < Number(order.billedPrice)" class="m-l-lg red"><i><b>Cash taken must be greater then billed price.</b></i></p>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary" :disabled="Number(cashTaken) < Number(order.billedPrice)">Finalize</button>
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    import PosCashTakenKeyPad from "@/components/pos/PosCashTakenKeyPad.vue";

    export default {
        name: "finalizeOrder",
        components: {PosCashTakenKeyPad},
        props:["order"],
        data: function() {
            return {
                userRole: "",
                actionBtnLoadingClass: "",
                punchOrderButton: false,
                paymentMethod:{
                    id:1
                },
                discountCode:"",
                cashCollected:0,
                selectedTable:[],
                discount:0,
                dicountCoupon:{},
                cashTaken: 0
            }
        },
      computed: {},
        created: function () {
            let loggedInUser = this.$store.state.user;
            if(loggedInUser){
                this.userRole = loggedInUser.userRolesById[0].role;
            }
        },
        mounted() {
          // this.cashTaken = this.order && this.order.billedPrice
        },
      watch: {
        order: {
          handler (val) {
            this.cashTaken = val.billedPrice
          },
          immediate: true,
          deep: true
        }
      },
      methods: {
            load: function (selectedTableOrder, selectedTable) {
                this.cashCollected=0;
                this.discountCode = "";
                    this.order = selectedTableOrder;
                    this.selectedTable=selectedTable;
                    $("#order_view_model").modal("show");
                    if (this.order.paymentMethod.id===1) {
                      this.$refs.keyPad.setCashTaken(this.order.billedPrice)
                    }
            },
            cashTakenFromPad(cashTaken) {
                  this.cashTaken = cashTaken
            },
            applyDiscount: function () {
                let params = new URLSearchParams();
                params.append("code", this.discountCode);
                params.append("restaurant_id",this.order.branchesByBranchId.restaurantsByRestaurantId.id)
                this.$http.post(this.$store.state.mainAppURL + "pos/apply_discount_in_pos", params).then(resp => {
                    if(resp.data === null || resp.data === "") {
                        swal("ERROR!", "Invalid Coupon or already reedemed! Contact DVM Tech Support", "error");
                        this.$parent.selectedTableOrder.discount=0;
                        this.discountCode = "";
                        return;
                    }
                    swal("SUCCESS!", "Coupon has been reedemed successfully!", "success");
                    this.dicountCoupon= resp.data;
                    this.$parent.selectedTableOrder.couponsByCouponId= resp.data;
                    this.$parent.calculateFinance();
                }).catch(ex => {
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
            removeDiscount: function () {
                this.$parent.selectedTableOrder.discount=0;
                this.$parent.selectedTableOrder.couponsByCouponId=null;
                this.discount=0;
                this.discountCode = "";
                this.$parent.calculateFinance();
                swal("SUCCESS!", "Coupon has been removed successfully!", "success");
            },
            ChangePayment: function(){
                this.$parent.selectedTableOrder.discount= (this.$parent.selectedTableOrder.totalPriceWithAddon /100)*this.discount;
                this.$parent.calculateFinance();
            },
        }
    }
</script>

<style scoped>
.red {
  color: red;
}
</style>
